import { defineStore } from 'pinia'
import { api } from '@/service/api'
import type { IndexerTokenResponse } from '@/interface/indexer/response/tokenResponse'
import { Meilisearch } from 'meilisearch'

type ClientPromiseType = Promise<Meilisearch>

export const useIndexerStore = defineStore('indexStore', () => {
  let clientPromiseCache: ClientPromiseType | null = null

  function getClient(): ClientPromiseType {
    let clientPromise: ClientPromiseType | null = clientPromiseCache
    if (clientPromise === null) {
      clientPromise = updateToken()
    }
    return clientPromise
  }

  async function updateToken(): ClientPromiseType {
    clientPromiseCache = new Promise(async (resolve, reject) => {
      const tokenResonse: IndexerTokenResponse = await api.get('/api/private/v1/indexer/token')
      if (!tokenResonse.token) {
        console.error('Failed to update indexer token')
        return reject()
      }

      resolve(
        new Meilisearch({
          host: `${document.location.origin}/indexer`,
          apiKey: tokenResonse.token,
        }),
      )
    })
    return clientPromiseCache
  }

  return {
    getClient,
    updateToken,
  }
})
